<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
</div>
<div class="modal-body">
  <div [innerHTML]="message"></div>
</div>
<div class="modal-footer">
  <button type="button" ngbAutofocus class="btn btn-light btn-sm" (click)="modal.dismiss('CANCEL_CLICK')" translate>
    Cancel
  </button>
  <button type="button" class="btn btn-primary btn-sm" (click)="modal.close('OK_CLICK')" translate>OK</button>
</div>
